module.exports = __webpack_public_path__ + "static/media/partner-11.9fafc323.png";